/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-05-31 14:23:29
 * @LastEditors: linxi
 * @LastEditTime: 2021-07-13 15:44:48
 */
import React, { ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { AccountBookOutlined } from '@ant-design/icons'
import { EditableList } from '../../../../compnents/list/EditableList'
import { NavBar } from '../../../../compnents/nav/NavBar'
import { AdditionDrugsColumns } from './column'
import { HeadQuery } from './Querys/headQuery'
import { ButtonQuery } from './Querys/buttonQuery'
import {
  getAddtionDrug,
  getAddtionDrugList,
  getExportKCYHExcelAsync,
  getMaintainCustomListAsync,
  removeDurgAsync,
  selectAddtionCurrent,
  selectAddtionDrugData,
  selectAddtionDrugHead,
  selectAddtionTotal,
  setAddtionCurrent,
  submitDurgAsync,
} from './addtionDrugSlice'
import styles from './additionDrug.module.css'
import { DataType } from '../../../putstorage/putstorage'
import {
  AddtionDrugParams,
  getAddtionDrugData,
} from '../../../../services/addtionDrug'
import { MintenanceModule } from './modal'
import { useLocation } from 'react-router'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../../../app/store'
import { Button, notification, Row, Table, Pagination } from 'antd'
import { maintenanceCompletedAsync } from '../StockMaintenance/stockMaintenanceSlice'
import { SJQXChecks } from '../../../../models/dataPersion'
import { getCheckPermissionAsync } from '../../../FunctionSetting/dataPermission/dataPermissionSlice'
export const AdditionDrug = (): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [queries, setQueries] = useState<AddtionDrugParams>()

  const location: any = useLocation()

  const [size, setSize] = useState(10)

  const [IsVisible, setIsVisible] = useState(false)

  const current = useSelector(selectAddtionCurrent)

  const total = useSelector(selectAddtionTotal)

  const data = useSelector(selectAddtionDrugData)

  const headDetail = useSelector(selectAddtionDrugHead)

  const [ids, setIds] = useState<any>()

  const [exportLoading, setExportLoading] = useState(false)
  const [groupData, setGroupData] = useState<Record<number, any[]>>({})

  const rowSelection = {
    preserveSelectedRowKeys: true,
    onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
      setIds(selectedRowKeys.join(','))
    },
  }
  const handleChange = (prev: any, next: any) => {
    const newdata: any = {
      ...prev,
      ...next,
    }
    dispatch(submitDurgAsync([newdata]))
      .then(unwrapResult)
      .then(() => {
        getAddtionDrugLists()
      })
  }

  useEffect(() => {
    if (location.state) {
      getAddtionDrugLists()
    }
  }, [location, size, current, queries])

  useEffect(() => {
   getMaintainCustomList()
  }, [])

  const getMaintainCustomList = () => {
     dispatch(getMaintainCustomListAsync())
      .then(unwrapResult)
      .then((res: any) => {
        const list = Array.isArray(res) ? res : (res?.records ?? res?.data ?? [])
         const grouped: Record<number, any[]> = { 0: [], 1: [], 2: [] }
        list.forEach((item: any) => {
          const t = Number(item?.type)
          if (t === 0 || t === 1 || t === 2) {
            grouped[t].push(item)
          }
        })
        setGroupData(grouped)
      })
      .catch(() => {
        return
      })
  }

  const getAddtionDrugLists = () => {
    dispatch(
      getAddtionDrugList({
        ...queries,
        current,
        size,
        tenantMaintainId: location.state.selectId,
      })
    )
    dispatch(
      getAddtionDrug({
        ...queries,
        current,
        size,
        tenantMaintainId: location.state.selectId,
      })
    )
  }

  // 库存养护导出
  const exportExcel = () => {
    setExportLoading(true)
    dispatch(
      getExportKCYHExcelAsync({
        ...queries,
        current,
        size,
        tenantMaintainId: location.state.selectId,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '库存养护.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
        })
      })
      .catch((res: any) => {
        return
      })
      .finally(() => {
        setExportLoading(false)
      })
  }
  return (
    <>
      <NavBar
        style={{ margin: '10px 20px 0px 20px' }}
        where={['库存管理', '库存养护单据']}
        backtrace={{
          name: '养护列表',
          path: '/stockMaintenance',
          routeName: '库房工作站',
        }}
        buttons={
          headDetail.state ? (
            <></>
          ) : (
            <Button
              type='link'
              onClick={() => {
                dispatch(maintenanceCompletedAsync(headDetail.id))
                  .then(unwrapResult)
                  .then(() => {
                    notification.success({
                      message: '养护完成',
                      duration: 3,
                    })
                    getAddtionDrugLists()
                  })
              }}
              style={{
                color: '#666',
              }}
            >
              <AccountBookOutlined />
              养护完成
            </Button>
          )
        }
      />
      <div className={styles.content}>
        <HeadQuery
          exportloading={exportLoading}
          detail={headDetail}
          exportKCYHExcel={() => {
            dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZDCDYQX }))
              .then(unwrapResult)
              .then((res: any) => {
                exportExcel()
              })
          }}
        />
        <ButtonQuery
          detail={headDetail}
          hasSelection={!!ids}
          onValueChange={(v) => {
            setQueries(v)
          }}
          onSave={() => {
            setIsVisible(true)
          }}
          onRemove={() => {
            dispatch(removeDurgAsync(ids))
              .then(unwrapResult)
              .then(() => {
                setIds('')
                dispatch(setAddtionCurrent(1))
                dispatch(
                  getAddtionDrug({
                    current,
                    size,
                    tenantMaintainId: location.state.selectId,
                    ...queries,
                  })
                )
              })
              .catch(() => {
                notification.error({
                  message: '请选择要删除的药品',
                  duration: 3,
                })
              })
          }}
          refresh={() => {
            getMaintainCustomList()
          }}
        />
        <EditableList
          pagination={false}
          className={styles.supper}
          rowKey={(t: any) => t.id}
          dataSource={data}
          columns={AdditionDrugsColumns(
            (t) => {
              handleChange(t.prev, t.next)
            },
            size * (current - 1),
            headDetail.state,
            groupData
          )}
          rowSelection={{
            // type: selectionType,
            ...rowSelection,
          }}
        ></EditableList>

        <Row style={{ justifyContent: 'flex-end' }}>
          <Pagination
            total={total}
            current={current}
            pageSize={size}
            showSizeChanger
            showQuickJumper
            pageSizeOptions={['10', '20', '50', '100', '500']}
            style={{
              marginTop: '10px',
            }}
            onChange={(current, pageSize) => {
              setSize(pageSize as number)
              dispatch(setAddtionCurrent(current))
            }}
          />
        </Row>
      </div>
      <MintenanceModule
        tenantMaintainId={location.state.selectId}
        maintainCategory={headDetail.maintainCategory}
        storehouseId={headDetail.storehouseId}
        visible={IsVisible}
        onOk={() => {
          setIsVisible(false)
          getAddtionDrugLists()
        }}
        onCancel={() => {
          setIsVisible(false)
        }}
      />
    </>
  )
}
